<template>
  <div class="space-y-4">
    <Field class="gap-1">
      <FieldLabel for="firstName">First Name</FieldLabel>
      <Input
        id="firstName"
        placeholder="Elon"
        :model-value="modelValue.firstName"
        @update:model-value="update('firstName', String($event))"
      />
    </Field>

    <Field class="gap-1">
      <FieldLabel for="lastName">Last Name</FieldLabel>
      <Input
        id="lastName"
        placeholder="Husk"
        :model-value="modelValue.lastName"
        @update:model-value="update('lastName', String($event))"
      />
    </Field>

    <PhoneInput
      label="Phone Number"
      placeholder="+1 (281) 330 8004"
      :model-value="modelValue.phone"
      @update:model-value="update('phone', $event)"
    />

    <Field class="gap-1">
      <FieldLabel for="email">Email</FieldLabel>
      <Input
        id="email"
        type="email"
        placeholder="you@example.com"
        :model-value="modelValue.email"
        @update:model-value="update('email', String($event))"
      />
    </Field>

    <Field class="gap-1">
      <FieldLabel>Stage</FieldLabel>
      <Select :model-value="modelValue.stage" @update:model-value="update('stage', String($event))">
        <SelectTrigger>
          <SelectValue placeholder="Select Stage" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem v-for="option in stageOptions" :key="option" :value="option">
            {{ option }}
          </SelectItem>
        </SelectContent>
      </Select>
    </Field>

    <Field class="gap-1">
      <FieldLabel>License Status</FieldLabel>
      <Select :model-value="modelValue.licenseStatus" @update:model-value="update('licenseStatus', String($event))">
        <SelectTrigger>
          <SelectValue placeholder="Select License Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem v-for="option in licenseStatusOptions" :key="option" :value="option">
            {{ option }}
          </SelectItem>
        </SelectContent>
      </Select>
    </Field>

    <Field class="gap-1">
      <FieldLabel for="reLicenseNumber">
        RE License Number <span class="text-xs text-muted-foreground">(optional)</span>
      </FieldLabel>
      <Input
        id="reLicenseNumber"
        placeholder="123456"
        :model-value="modelValue.reLicenseNumber"
        @update:model-value="update('reLicenseNumber', String($event))"
      />
    </Field>

    <Field class="gap-1">
      <FieldLabel for="phoneScreenAt">
        Phone Screen At <span class="text-xs text-muted-foreground">(optional)</span>
      </FieldLabel>
      <Input
        id="phoneScreenAt"
        type="datetime-local"
        :model-value="modelValue.phoneScreenAt"
        @update:model-value="update('phoneScreenAt', String($event))"
      />
    </Field>

    <Field class="gap-1">
      <FieldLabel for="interviewAt">
        Interview At <span class="text-xs text-muted-foreground">(optional)</span>
      </FieldLabel>
      <Input
        id="interviewAt"
        type="datetime-local"
        :model-value="modelValue.interviewAt"
        @update:model-value="update('interviewAt', String($event))"
      />
    </Field>
  </div>
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input';
import { Field, FieldLabel } from '@/components/ui/field';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import PhoneInput from '../shared/PhoneInput.vue';

type ContactFormData = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  stage: string;
  licenseStatus: string;
  reLicenseNumber: string;
  phoneScreenAt: string;
  interviewAt: string;
};

const props = defineProps<{
  modelValue: ContactFormData;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: ContactFormData];
}>();

const stageOptions = ['Applied', 'Phone Screen', 'Interview', 'Onboarding', 'Hired', 'Nurture', 'Disqualified'];
const licenseStatusOptions = ['Licensed', 'License In Progress', 'Unlicensed', 'Unknown'];

const update = (key: keyof ContactFormData, value: string): void => {
  emit('update:modelValue', { ...props.modelValue, [key]: value });
};
</script>
